import { CommentsActions, CommentsActionTypes } from '@dwo/actions';
import { CommentDto } from '@app/generated/model';

export const initialState: CommentsState = {
  mipsComments: [],
  commentCount: 0,
  materialCommentCount: 0,
  workLineCommentCount: 0,
};

export interface CommentsState {
  mipsComments: CommentDto[];
  commentCount: number;
  materialCommentCount: number;
  workLineCommentCount: number;
}

export function commentsReducer(state: CommentsState = initialState, action: CommentsActions): CommentsState {
  switch (action.type) {
    case CommentsActionTypes.LoadMIPSCommentsSuccess:
      return {
        ...state,
        mipsComments: action.commentDtos,
      };
    case CommentsActionTypes.AddComment:
      return {
        ...state,
        commentCount: state.commentCount + 1,
        materialCommentCount: state.materialCommentCount + (action.isMaterial ? 1 : 0),
        workLineCommentCount: state.workLineCommentCount + (action.isWorkLine ? 1 : 0),
      };
    case CommentsActionTypes.DeleteComment:
      return {
        ...state,
        commentCount: state.commentCount - 1,
        materialCommentCount: state.materialCommentCount - (action.isMaterial ? 1 : 0),
        workLineCommentCount: state.workLineCommentCount - (action.isWorkLine ? 1 : 0),
      };
    case CommentsActionTypes.LoadCommentCountSuccess:
      return {
        ...state,
        commentCount: action.comments,
        materialCommentCount: action.materialComments,
        workLineCommentCount: action.workLineComments,
      };
    default:
      return {
        ...state,
      };
  }
}
